"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("@qwkin/helpers");
var _ImageUploader = require("./ImageUploader.styles");
var _ResponsiveImage = require("../ResponsiveImage");
var _Avatar = require("../Avatar");
var _Button = require("../Button");
var _Text = require("../Text");
var _ImageUploaderModal = _interopRequireDefault(require("./ImageUploaderModal"));
var _theme = require("../utils/theme");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ImageFormats = Object.freeze({
  ROUND: 'round',
  SQUARE: 'square'
});
var ImageUploader = function ImageUploader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Image Uploader' : _ref$title,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$onComplete = _ref.onComplete,
    _onComplete = _ref$onComplete === void 0 ? _helpers.identity : _ref$onComplete,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? ImageFormats.SQUARE : _ref$format,
    src = _ref.src,
    limitedSizeImage = _ref.limitedSizeImage,
    _ref$oversizeMessage = _ref.oversizeMessage,
    oversizeMessage = _ref$oversizeMessage === void 0 ? 'Exceeded image size.' : _ref$oversizeMessage,
    previewRender = _ref.previewRender,
    helperText = _ref.helperText,
    additionalOptions = _ref.additionalOptions,
    _ref$isErasable = _ref.isErasable,
    isErasable = _ref$isErasable === void 0 ? false : _ref$isErasable,
    s3Key = _ref.s3Key,
    s3Bucket = _ref.s3Bucket;
  var _useState = (0, _react.useState)(src),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    image = _useState2[0],
    setImage = _useState2[1];
  var _useState3 = (0, _react.useState)(!image && !s3Key && !s3Bucket),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isEmptyImage = _useState4[0],
    setIsEmptyImage = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isImageModalVisible = _useState6[0],
    setImageModalVisibility = _useState6[1];
  return /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderContainer, null, /*#__PURE__*/_react["default"].createElement(_ImageUploaderModal["default"], {
    theme: theme,
    format: format,
    title: title,
    helperText: helperText,
    isOpen: isImageModalVisible,
    isErasable: isErasable,
    limitedSizeImage: limitedSizeImage,
    oversizeMessage: oversizeMessage,
    onClose: function onClose() {
      return setImageModalVisibility(false);
    },
    previewRender: previewRender,
    src: image,
    s3Key: isEmptyImage || image ? undefined : s3Key,
    s3Bucket: isEmptyImage || image ? undefined : s3Bucket,
    onComplete: function onComplete(editedFile, editedSrc) {
      setIsEmptyImage(!editedFile && !editedSrc);
      setImage(editedSrc);
      _onComplete(editedFile, editedSrc);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    weight: "bold"
  }, title), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderDivider, null), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderContent, null, format === ImageFormats.SQUARE && (!image && s3Key && s3Bucket ? /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.ResponsiveImage, {
    shouldZoom: true,
    aspectRatio: "88 / 45",
    containerStyle: {
      borderRadius: '10px'
    },
    s3Key: isEmptyImage || image ? undefined : s3Key,
    s3Bucket: isEmptyImage || image ? undefined : s3Bucket
  }) : /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.ResponsiveImage, {
    src: image,
    shouldZoom: true,
    aspectRatio: "88 / 45",
    containerStyle: {
      borderRadius: '10px'
    }
  })), format === ImageFormats.ROUND && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Avatar.Avatar, {
    size: "120",
    borderRadius: "10px",
    preview: image,
    s3Key: isEmptyImage ? undefined : s3Key,
    s3Bucket: isEmptyImage ? undefined : s3Bucket
  })), /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderButtonsRow, null, additionalOptions, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    dense: true,
    outline: true,
    icon: "upload",
    onClick: function onClick() {
      return setImageModalVisibility(true);
    }
  }, !isEmptyImage ? 'Edit Picture' : 'Upload Picture'))));
};
var _default = exports["default"] = ImageUploader;